import React from 'react';
import AeoScan from '../../components/AeoScan/AeoScan';
import Canonical from '../../utils/Canonical';

const AeoScanPage = () => {
  return (
    <>
      <Canonical path='/aeo-auditor' title='AEO/GEO Score Auditor' />
      <AeoScan />
    </>
  );
};

export default AeoScanPage;
